export const CAI_QA_SUPABASE_PROJECT_REF = "jfuyhcmvbozsvykwzqua";

function projectRefFromSupabaseUrl(value) {
  try {
    const host = new URL(value).hostname.toLowerCase();
    const match = host.match(/^([a-z0-9-]+)\.supabase\.co$/);
    return match ? match[1] : "";
  } catch {
    return "";
  }
}

/**
 * Require an exact QA backend identity whenever a Preview or QA binding is
 * present. The expected ref is pinned in source so a misconfigured expected
 * ref cannot bless a Production URL.
 */
export function validateCaiQaSupabaseIdentity({
  deploymentEnvironment,
  qaMode,
  expectedProjectRef,
  supabaseUrl,
} = {}) {
  const qaBindingsPresent = qaMode !== undefined || expectedProjectRef !== undefined;
  const guardRequired = deploymentEnvironment === "preview" || qaBindingsPresent;
  if (!guardRequired) return { ok: true, guarded: false };

  const ok = qaMode === "true"
    && expectedProjectRef === CAI_QA_SUPABASE_PROJECT_REF
    && projectRefFromSupabaseUrl(supabaseUrl) === CAI_QA_SUPABASE_PROJECT_REF;
  return { ok, guarded: true };
}
